import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const TopBarSlotsContext = createContext({
  leftSlotEl: null,
  setLeftSlotEl: () => {},
  leftSlotOccupied: false,
  setLeftSlotOccupied: () => {},
});

export const TopBarSlotsProvider = ({ children }) => {
  const [leftSlotEl, setLeftSlotEl] = useState(null);
  const [leftSlotOccupied, setLeftSlotOccupiedState] = useState(false);

  const setLeftSlotOccupied = useCallback((occupied) => {
    setLeftSlotOccupiedState(Boolean(occupied));
  }, []);

  const value = useMemo(
    () => ({
      leftSlotEl,
      setLeftSlotEl,
      leftSlotOccupied,
      setLeftSlotOccupied,
    }),
    [leftSlotEl, leftSlotOccupied, setLeftSlotOccupied],
  );

  return (
    <TopBarSlotsContext.Provider value={value}>
      {children}
    </TopBarSlotsContext.Provider>
  );
};

export const useTopBarSlots = () => useContext(TopBarSlotsContext);

export default TopBarSlotsProvider;
